import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import getText from 'context/language/getText';
import { BodyLarge, BodyRegular } from 'components/common_v2/typography';
import { useStyles } from './styled';

export const ApproachingCreditLimit = ({ user }) => {
  const classes = useStyles();

  return (
    <div>
      <BodyLarge className={classes.warning}>
        {getText('banners.approachingCreditLimit.title')}
      </BodyLarge>
      <BodyRegular className={classes.warning}>
        {getText('banners.approachingCreditLimit.body', {
          displayCreditLimit: get(user, 'customer.displayCreditLimit', null),
          currentBalance: get(user, 'customer.currentBalance', null)
        })}
      </BodyRegular>
    </div>
  );
};

ApproachingCreditLimit.propTypes = {
  user: PropTypes.object
};

ApproachingCreditLimit.defaultProps = {
  user: {}
};
